import { createUseStyles } from 'react-jss';
import { Theme } from '@mui/material';

export const useStyles = createUseStyles((theme: Theme) => {
    const { color, radius, mq, motion, font } = theme.custom;
    return {
        container: { maxHeight: 'calc(100vh - 340px)', minHeight: 240 },
        idButton: {
            padding: '2px 6px',
            margin: '-2px -6px',
            border: 'none',
            background: 'transparent',
            fontFamily: font.mono,
            fontSize: 13,
            fontWeight: 600,
            color: color.text.primary,
            cursor: 'pointer',
            borderRadius: radius.xs,
            '&:hover': { color: color.primary.main, textDecoration: 'underline' },
            '&:focus-visible': { outline: `2px solid ${color.focusRing}` },
        },
        numeric: { textAlign: 'right', fontVariantNumeric: 'tabular-nums', whiteSpace: 'nowrap' },
        rate: { display: 'block', fontSize: 11, color: color.text.secondary },
        date: { whiteSpace: 'nowrap', fontVariantNumeric: 'tabular-nums' },
        actions: { display: 'flex', justifyContent: 'flex-end', gap: 6, whiteSpace: 'nowrap' },
        note: { width: '100%', margin: 0, fontSize: 12, color: color.text.secondary },
        cards: { display: 'flex', flexDirection: 'column', gap: 10, padding: 12 },
        card: {
            padding: 14,
            borderRadius: radius.md,
            border: `1px solid ${color.border}`,
            backgroundColor: color.surfaceRaised,
            transitionProperty: 'border-color',
            transitionDuration: motion.fast,
        },
        cardTop: { display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 10, marginBottom: 10 },
        cardId: { fontFamily: font.mono, fontSize: 15, fontWeight: 600 },
        cardGrid: { display: 'grid', gridTemplateColumns: 'repeat(3, minmax(0, 1fr))', gap: '8px 12px', fontSize: 13, [mq.xs]: { gridTemplateColumns: 'repeat(2, minmax(0, 1fr))' } },
        cardLabel: { fontSize: 11, color: color.text.secondary, display: 'block', marginBottom: 2 },
        cardValue: { fontVariantNumeric: 'tabular-nums', color: color.text.primary, overflowWrap: 'anywhere' },
        cardActions: { display: 'flex', justifyContent: 'flex-end', gap: 8, marginTop: 12 },
    };
});
